module.exports = __webpack_public_path__ + "media/images/mobile/problem-mobile-dca8c9ce10a0a9ab7323b34dd09742aa.jpg";